"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=maker-finalized-proposal.js.map